export default "__VITE_ASSET__1c44e1d4__"